$(document).ready(function () {
  jQuery(".cart_template-wrapper,.cart__footer-wrapper").wrapAll(
    '<div class="main-cart"><div class="row"></div></div>'
  );
  /*--------------- Scroll to top js -------------------*/
  (function ($) {
    "use strict";

    $(document).ready(function () {
      "use strict";

      var progressPath = document.querySelector(".progress-wrap path");
      var pathLength = progressPath.getTotalLength();
      progressPath.style.transition = progressPath.style.WebkitTransition =
        "none";
      progressPath.style.strokeDasharray = pathLength + " " + pathLength;
      progressPath.style.strokeDashoffset = pathLength;
      progressPath.getBoundingClientRect();
      progressPath.style.transition = progressPath.style.WebkitTransition =
        "stroke-dashoffset 10ms linear";
      var updateProgress = function () {
        var scroll = $(window).scrollTop();
        var height = $(document).height() - $(window).height();
        var progress = pathLength - (scroll * pathLength) / height;
        progressPath.style.strokeDashoffset = progress;
      };
      updateProgress();
      $(window).scroll(updateProgress);
      var offset = 50;
      var duration = 550;
      jQuery(window).on("scroll", function () {
        if (jQuery(this).scrollTop() > offset) {
          jQuery(".progress-wrap").addClass("active-progress");
        } else {
          jQuery(".progress-wrap").removeClass("active-progress");
        }
      });
      jQuery(".progress-wrap").on("click", function (event) {
        event.preventDefault();
        jQuery("html, body").animate({ scrollTop: 0 }, duration);
        return false;
      });
    });
  })(jQuery);
  /*-------------------- END ------------------*/
  $(".headerbanner-close").on("click", function () {
    $(".announce-banner").slideToggle("slow", function () {});
    jQuery("body").addClass("headerbanner-close");
  });

jQuery(".nav-toggle").click(function (event) {
  jQuery(this).toggleClass("active");
  event.stopPropagation();
  jQuery("#mobile-drawer, #drawer-overlay").fadeToggle(300);
  jQuery("body").toggleClass("open-header");
});
jQuery("#drawer-close, #drawer-overlay").on("click", function () {
  jQuery("#mobile-drawer, #drawer-overlay").fadeOut(300);
  jQuery(".nav-toggle").removeClass("active");
  jQuery("body").removeClass("open-header");
});


  jQuery(".nav-toggle").click(function (event) {
    jQuery(this).toggleClass("active");
    event.stopPropagation();
    jQuery("#tt-megamenu .tt-mega_menu, .tt-mega_menu").slideToggle("2000");
    jQuery("body").toggleClass("open-header");
  });
  jQuery("#tt-megamenu .tt-mega_menu").on("click", function (event) {
    event.stopPropagation();
    jQuery(this).removeClass("active");
  });
  jQuery("#tt-megamenu .tt-mega_menu").hover(
    function () {
      jQuery("body").addClass("menu_hover");
    },
    function () {
      jQuery("body").removeClass("menu_hover");
    }
  );

  /*------------------------testimonial-video-----------------*/

  var k = jQuery(".parallax_vid");

  jQuery("#playbtn").click(function () {
    k.css("display", "block");
  });

  jQuery(".vid_close").click(function () {
    l = event || window.event;
    if (l.target == this) {
      jQuery(k).css("display", "none");
    }
  });
  /*-------------------- Filter toggle ------------------*/
  jQuery(".filter-toggle").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".filter-toggle-wrap").slideToggle("is-visible");
  });
  var filter = jQuery(this).find(".full_width .sorting_wrapper");
  jQuery(this).find(".filter-toggle").insertBefore(filter);
  /*-------------------- END ------------------*/
  /*--------------------Mobile Sticky--------------------*/
  function stickyScroll() {
    if (
      $(window).scrollTop() > 100 &&
      $(".main-sticky-data").attr("data-hidden") == 1
    ) {
      $(".main-sticky-data").attr("data-hidden", 0);
      $(".main-sticky-data").addClass("fixed");
    } else if (
      $(window).scrollTop() < 100 &&
      $(".main-sticky-data").attr("data-hidden") == 0
    ) {
      $(".main-sticky-data").attr("data-hidden", 1);
      $(".main-sticky-data").removeClass("fixed");
    } else if (
      $(window).scrollTop() ==
      $(document).height() - $(window).height()
    ) {
      $(".main-sticky-data").attr("data-hidden", 1);
      $(".main-sticky-data").removeClass("fixed");
    }
  }
  $(window).scroll(function () {
    stickyScroll();
  });
  /*---------------------------END-------------------------------*/

 


  jQuery(".product-single__thumbs img").on("click", function () {
    var src = jQuery(this).attr("src");
    if (src != "") {
      jQuery(this)
        .closest(".product-wrapper")
        .find("img.grid-view-item__image")
        .first()
        .attr("src", src);
    }
    jQuery(this)
      .parent(".grid-item")
      .addClass("open")
      .siblings(".grid-item")
      .removeClass("open");
  });

  /*-------------------- video -------------------*/
  var p = jQuery(".popup_overlay");
  jQuery(".play-icone").click(function () {
    jQuery("body").addClass("popup-toggle");
    p.css("display", "block");
  });
  p.click(function (event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css("display", "none");
      jQuery("body").removeClass("popup-toggle");
    }
  });
  //video popup
  function toggleVideo(state) {
    // if state == 'hide', hide. Else: show video
    var div = document.getElementById("popupVid");
    var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
    //div.style.display = state == 'hide' ? 'none' : '';
    func = state == "hide" ? "pauseVideo" : "playVideo";
    iframe.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      "*"
    );
  }
  jQuery(".play-icone").click(function () {
    p.css("visibility", "visible").css("opacity", "1");
  });
  p.click(function (event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css("visibility", "hidden").css("opacity", "0");
      toggleVideo("hide");
    }
  });
  /*------------------------- Checkout button --------------------*/
  jQuery(".shopify-payment-button .shopify-payment-button__button").prepend(
    jQuery("<i class='mdi mdi-cart-outline'></i>")
  );
  /*----------------------------------------------*/
  var w_width = $(window).width();
  $(".slider-content-main-wrap").css("width", w_width);
  if ($(".site-header").hasClass("header_transaparent")) {
    $("body.template-index").addClass("header_transaparent");
  }
  /*----------------------- filter ----------------------*/
  jQuery(".filter-left").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-left").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
      "is-visible is-closable"
    );
  });
  jQuery(".filter-right").on("click", function (e) {
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-right").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
      "is-visible is-closable"
    );
  });
  jQuery(".off-canvas .sidebar_close").on("click", function (e) {
    e.preventDefault();
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
      "is-visible is-closable"
    );
  });
  jQuery(".is-overlay-fixed").on("click", function (e) {
    e.preventDefault();
    jQuery(".filter-left").trigger("click");
    jQuery(".filter-right").trigger("click");
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
      "is-visible is-closable"
    );
  });
  $(".product-360-button a").magnificPopup({
    type: "inline",
    mainClass: "mfp-fade",
    removalDelay: 160,
    disableOn: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function () {
        $(window).resize();
      },
    },
  });
  countDownIni(".flip-countdown,.js-flip-countdown");
  /*--------------- popup Video ---------------------*/
  $(".popup-video").magnificPopup({
    disableOn: 300,
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });
  if (
    $("a.product-lightbox-btn").length > 0 ||
    $("a.product-video-popup").length > 0
  ) {
    $(".product-single__photos .gallery,.design_2 .pro_img").magnificPopup({
      delegate: "a", // child items selector, by clicking on it popup will open
      type: "image",
      tLoading:
        '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: true,
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        preload: [0, 1],
      },
      image: {
        verticalFit: false,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      },
      callbacks: {
        beforeOpen: function () {
          var productVideo = $(".product-video-popup").attr("href");
          if (productVideo) {
            this.st.mainClass = "has-product-video";
            var galeryPopup = $.magnificPopup.instance;
            galeryPopup.items.push({
              src: productVideo,
              type: "iframe",
            });
            galeryPopup.updateItemHTML();
          }
        },
        open: function () {},
      },
    });
  }

  /*-------------- Quantity Start -------------------*/
  $(".qtyplus").on("click", function (e) {
    e.preventDefault();
    var input_val = jQuery(this).parents(".qty-box-set").find(".quantity");
    var currentVal = parseInt(
      jQuery(this).parents(".qty-box-set").find(".quantity").val()
    );
    var update = jQuery(".cart-update .quantity").data("item-id");
    if (!isNaN(currentVal)) {
      jQuery(this)
        .parents(".qty-box-set")
        .find(".quantity")
        .val(currentVal + 1);
    } else {
      jQuery(this).parents(".qty-box-set").find(".quantity").val(1);
    }
  });
  $(".qtyminus").on("click", function (e) {
    e.preventDefault();
    var input_val = jQuery(this).parents(".qty-box-set").find(".quantity");
    var currentVal = parseInt(
      jQuery(this).parents(".qty-box-set").find(".quantity").val()
    );
    if (!isNaN(currentVal) && currentVal > 1) {
      jQuery(this)
        .parents(".qty-box-set")
        .find(".quantity")
        .val(currentVal - 1);
    } else {
      jQuery(this).parents(".qty-box-set").find(".quantity").val(1);
    }
  });



  

  
  /*---------------- END ------------------*/

  $("#navToggle").on("click", function (e) {
    jQuery(this).next(".Site-navigation").slideToggle(500);
  });
  $(".menu_toggle_wrap #navToggle").on("click", function (e) {
    jQuery(this).parent().next(".Site-navigation").slideToggle(500);
  });

  jQuery("body.footer_style_1 .footer_toggle").on("click", function (e) {
    jQuery("#shopify-section-footer-model-1").addClass("toggle-footer");
    jQuery("body").addClass("footer1-open");
    e.preventDefault();
  });

  jQuery("body.footer_style_1 .footer_close_toggle").on("click", function (e) {
    jQuery("#shopify-section-footer-model-1").removeClass("toggle-footer");
    jQuery("body").removeClass("footer1-open");
    e.preventDefault();
  });

  jQuery("body.footer_style_2 .footer_toggle").on("click", function (e) {
    jQuery("#shopify-section-footer-model-2").addClass("toggle-footer");
    jQuery("body").addClass("footer2-open");
    e.preventDefault();
  });

  jQuery("body.footer_style_2 .footer_close_toggle").on("click", function (e) {
    jQuery("#shopify-section-footer-model-2").removeClass("toggle-footer");
    jQuery("body").removeClass("footer2-open");
    e.preventDefault();
  });

  jQuery(".header_1 .fullscreen_header_toggle").on("click", function (e) {
    jQuery(this).toggleClass("active");
    //     jQuery("body").toggleClass("fullnav-open header_1");
    e.preventDefault();
  });
  jQuery(".header_2 .fullscreen_header_toggle").on("click", function (e) {
    jQuery(this).toggleClass("active");
    //     jQuery("body").toggleClass("fullnav-open header_2");
    e.preventDefault();
  });
  /*-------------- Search js ----------------*/
  jQuery(".site-header__search.search-full .serach_icon").on(
    "click",
    function (e) {
      e.preventDefault();
      jQuery(this).toggleClass("active");
      jQuery("body").toggleClass("search_full_active");
      jQuery(".search-full-screen").slideToggle("slow");
      jQuery(".full-search-wrapper").addClass("search-overlap");
      jQuery(".right-link-icon .myaccount").removeClass("open");
      jQuery(".right-link-icon .myaccount  .customer_account").slideUp("fast");
      jQuery(".site-header .site-header_cart_link").removeClass("active");
      jQuery(".fixed-cart-wrap").removeClass("active");
      jQuery(".search-bar > input").focus();
      jQuery("body").toggleClass("search_toggle");
      jQuery("body").removeClass("account-toggle");
      jQuery("body").removeClass("cart_toggle");
    }
  );
  jQuery(".site-header__search.search-full .close-search").on(
    "click",
    function () {
      jQuery(".site-header__search.search-full .serach_icon").removeClass(
        "active"
      );
      jQuery(".full-search-wrapper").removeClass("search-overlap");
      jQuery("body").removeClass("search_full_active");
      jQuery("body").removeClass("search_toggle");
      jQuery(".search-full-screen").slideUp("slow");
    }
  );
  /*-------------------- Myaccount -----------------*/
  jQuery(".myaccount  span.dropdown-toggle").on("click", function (event) {
    event.preventDefault();
    jQuery(".customer_account").slideToggle("fast");
    jQuery(this).toggleClass("open");
    jQuery("body").toggleClass("account-toggle");
    jQuery(".search_wrapper").slideUp("fast");
    jQuery(".site-header__search:not(.search-full) .serach_icon").removeClass(
      "active"
    );
    jQuery("body").removeClass("search_full_active");
    jQuery("body").removeClass("currency-open");
    jQuery("body").removeClass("language-open");
    jQuery(".site-header .site-header_cart_link").removeClass("active");
    jQuery(".fixed-cart-wrap").removeClass("active");
    if ($(window).width() >= 992) {
      jQuery(".currencies.flag-dropdown-menu").slideUp("fast");
      jQuery(".header_language .disclosure-list").slideUp("fast");
    }
    jQuery("body").removeClass("search_toggle");
    jQuery("body").removeClass("cart_toggle");
  });

  function languagecurrency() {
      jQuery(".header_language .disclosure__toggle").on(
        "click",
        function (event) {
          // event.preventDefault();
          jQuery("body").toggleClass("language-open");
          jQuery("body").removeClass("currency-open");
          jQuery("body").removeClass("myaccount_active");
          jQuery("body").removeClass("cart_toggle");
          jQuery(".currency_wrapper").removeClass("active");
          jQuery(".disclosure-list").slideToggle("fast");
          jQuery(this).toggleClass("active");
          jQuery(".customer_account").slideUp("fast");
          jQuery(".currencies.flag-dropdown-menu").slideUp("fast");
          jQuery(".fixed-cart-wrap").removeClass("active");
        }
      );

      $(".header_currency .currency_wrapper.dropdown-toggle").on(
        "click",
        function (event) {
          // event.preventDefault();
          jQuery("body").toggleClass("currency-open");
          jQuery("body").removeClass("language-open");
          jQuery("body").removeClass("myaccount_active");
          jQuery("body").removeClass("cart_toggle");
          jQuery(".disclosure__toggle").removeClass("active");
          jQuery(".currencies.flag-dropdown-menu").slideToggle("fast");
          $(this).toggleClass("active");
          jQuery(".customer_account").slideUp("fast");
          jQuery(".header_language .disclosure-list").slideUp("fast");
          jQuery(".fixed-cart-wrap").removeClass("active");
        }
      );
  }
  $(document).ready(function () {
    languagecurrency();
  });
  jQuery(document).on("click", function (event) {
    var myacc = jQuery(".myaccount .dropdown-toggle")[0];
    var myaccont = jQuery(".myaccount .dropdown-toggle");

    if (
      myaccont !== event.target &&
      !myaccont.has(event.target).length &&
      myacc !== event.target
    ) {
      jQuery(".customer_account").slideUp("fast");
      jQuery("body").removeClass("account-toggle");
      jQuery(".myaccount .dropdown-toggle").removeClass("open");
    }

    var searchtog = jQuery(".site-header__search")[0];
    var searchtoggle = jQuery(".site-header__search");

    if (
      searchtoggle !== event.target &&
      !searchtoggle.has(event.target).length &&
      searchtog !== event.target
    ) {
      jQuery(".search-full-screen").slideUp("slow");
      jQuery("body").removeClass("search_full_active");
      jQuery("body").removeClass("search_toggle");
      jQuery(".search_toggle").removeClass("active");
    }

    if ($(window).width() >= 992) {
      var langu = jQuery(".language")[0];
      var language = jQuery(".language");

      if (
        language !== event.target &&
        !language.has(event.target).length &&
        langu !== event.target
      ) {
        jQuery("#lang-list").slideUp("fast");
        jQuery("body").removeClass("language-open");
        jQuery(".language_wrapper").removeClass("active");
      }

      var curr = jQuery(".currency")[0];
      var currency = jQuery(".currency");

      if (
        currency !== event.target &&
        !currency.has(event.target).length &&
        curr !== event.target
      ) {
        jQuery(".currencies").slideUp("fast");
        jQuery("body").removeClass("currency-open");
        jQuery(".currency_wrapper").removeClass("active");
      }
    }
  });
  /*-------------------- END -----------------*/

  $(".slider-specialproduct .product-wrapper").each(function () {
    var $desc = $(this).find(".product-description .progress");
    var $qty = $(this).find(".quantity");
    var $pbar = $(this).find(".progress-bar");
    var $progress = $desc;
    var $progressBar = $pbar;
    var $quantity = $qty.html();
    console.log($quantity);
    var currentWidth = parseInt($progressBar.css("width"));
    var allowedWidth = parseInt($progress.css("width"));
    var addedWidth = currentWidth + parseInt($quantity);
    if (addedWidth > allowedWidth) {
      addedWidth = allowedWidth;
    }
    var progress = (addedWidth / allowedWidth) * 100;
    $progressBar.animate({ width: progress + "%" }, 100);
  });
  $(".product-single").each(function () {
    var $desc = $(this).find(".product-information .progress");
    var $qty = $(this).find(".quantity");
    var $pbar = $(this).find(".progress-bar");
    var $progress = $desc;
    var $progressBar = $pbar;
    var $quantity = $qty.html();
    console.log($quantity);
    var currentWidth = parseInt($progressBar.css("width"));
    var allowedWidth = parseInt($progress.css("width"));
    var addedWidth = currentWidth + parseInt($quantity);
    if (addedWidth > allowedWidth) {
      addedWidth = allowedWidth;
    }
    var progress = (addedWidth / allowedWidth) * 100;
    $progressBar.animate({ width: progress + "%" }, 100);
  });

  /*-------------------------gallery------------------*/

  jQuery(".spr-summary-actions-newreview").on("click", function (e) {
    e.preventDefault();
    jQuery(".spr-content").slideToggle("slow");
  });

  if (
    $("body:not(.template-index) .site-header .toggle_menu").hasClass(
      "current-close"
    )
  ) {
    $(".tt-mega_menu").slideUp("2000");
  }
  $(".toggle_menu").click(function () {
    if ($(this).hasClass("default-open") && $(window).width() < 992) {
      if ($(this).hasClass("current-close")) {
        $(this).addClass("current-open");
        $("body").addClass("menu-current-open");
        $(this).removeClass("current-close");
        $(".tt-mega_menu").slideToggle("2000");
      } else {
        $(this).removeClass("default-open");
        $(this).addClass("current-open");
        $("body").addClass("menu-current-open");
        $(this).removeClass("current-close");
        $(".tt-mega_menu").slideToggle("2000");
      }
    } else if ($(this).hasClass("default-open")) {
      if ($(this).hasClass("current-close")) {
        $(this).addClass("current-open");
        $("body").addClass("menu-current-open");
        $(this).removeClass("current-close");
        $(".tt-mega_menu").slideToggle("2000");
      } else if ($(this).hasClass("current-open")) {
        $(this).addClass("current-close");
        $(this).removeClass("current-open");
        $("body").removeClass("menu-current-open");
        $(".tt-mega_menu").slideToggle("2000");
      }
    } else {
      if ($(this).hasClass("current-open")) {
        $(this).addClass("current-close");
        $("body").removeClass("menu-current-open");
        $(this).removeClass("current-open");
        $(".tt-mega_menu").slideToggle("2000");
      } else {
        $(this).addClass("current-open");
        $(this).removeClass("current-close");
        $("body").addClass("menu-current-open");
        $(".tt-mega_menu").slideToggle("2000");
      }
    }
    if (
      $(this).hasClass("default-open") &&
      !$(".sticky_header").hasClass("fixed")
    ) {
      $(this).addClass("current-close");
      $(this).removeClass("default-open");
      $(".tt-mega_menu").slideToggle("2000");
    }
    if (
      $(this).hasClass("default-open") &&
      $(".sticky_header").hasClass("fixed")
    ) {
      $(this).addClass("current-open");
      $("body").addClass("menu-current-open");
      $(this).removeClass("default-open");
      $(".tt-mega_menu").slideDown("2000");
    }
  });

  $(
    ".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js"
  ).click(function () {
    $(this).addClass("loading");
    setTimeout(function () {
      $(
        ".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a, .pro_btn.add-to-compare .add-in-compare-js"
      ).removeClass("loading");
    }, 2000);
  });

  var prevScrollpos = window.pageYOffset;
  window.onscroll = function (e) {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      document.getElementById("header-sticky").style.top = "0";
    } else if (
      $("body").hasClass("account-toggle") ||
      $("body").hasClass("menu_hover") ||
      $("body").hasClass("cart_toggle") ||
      $("body").hasClass("search_toggle")
    ) {
      document.getElementById("header-sticky").style.top = "0";
      e.stopPropagation();
    } else {
      document.getElementById("header-sticky").style.top = "-150px";
    }
    prevScrollpos = currentScrollPos;
  };
});
/*------------------------ END ------------------------*/
jQuery(window).scroll(function () {
  if (jQuery(document).height() > jQuery(window).height()) {
    var scroll = jQuery(window).scrollTop();
    if (scroll > 100) {
      jQuery("#GotoTop").fadeIn();
    } else {
      jQuery("#GotoTop").fadeOut();
    }
  }
});

function responsiveMenus() {
  if (jQuery(window).width() < 481) {
    jQuery(".category_feature .cat_content").removeClass("odd");
    jQuery(".category_feature .cat_content").removeClass("even");
    jQuery(".category_feature .cat_content .main_cat_content").each(function (
      index,
      element
    ) {
      var html = "";
      html +=
        '<div class="collection_img left-block">' +
        jQuery(element).find(".left-block").html() +
        "</div>";
      html +=
        '<div class="ttcat-content right-block">' +
        jQuery(element).find(".right-block").html() +
        "</div>";

      jQuery(element).html(html);
    });
  } else if (jQuery(window).width() >= 481) {
    jQuery(".category_feature .cat_content:odd").addClass("odd");
    jQuery(".category_feature .cat_content:even").addClass("even");

    jQuery(".category_feature .cat_content.odd .main_cat_content").each(
      function (index, element) {
        var html = "";
        html +=
          '<div class="ttcat-content right-block">' +
          jQuery(element).find(".right-block").html() +
          "</div>";
        html +=
          '<div class="collection_img left-block">' +
          jQuery(element).find(".left-block").html() +
          "</div>";
        jQuery(element).html(html);
      }
    );
  }
}
jQuery(document).ready(function () {
  responsiveMenus();
});
jQuery(window).resize(function () {
  responsiveMenus();
});

function responsiveMenu() {
  if (jQuery(window).width() < 992) {
    // jQuery("#shopify-section-TT-megamenu").insertAfter(".menu_wrapper .menu_toggle_wrap .nav-toggle");
    jQuery(".sub-nav__dropdown").css("display", "none");
    jQuery(".header_1 #shopify-section-TT-megamenu").appendTo(
      ".header_1 .menu_toggle_wrap"
    );

        jQuery(".header_1 .tt_menus_ul1 .tt_menu_item.item").appendTo(".header_1 .tt-megamenu .tt-mega_menu .tt_menus_ul");
    

            jQuery(".top_header_1 .top_header_1_link .header-contact ").insertAfter(" #shopify-section-TT-megamenu .tt-mega_menu .tt_menus_ul");



    

    jQuery(".header_2 .header_language").appendTo(
      ".myaccount .customer_account > ul"
    );
    jQuery(".header_2 .header_currency").insertAfter(
      ".myaccount .customer_account .header_language"
    );
  } else {
    jQuery(".header_1 #shopify-section-TT-megamenu").insertBefore(
      ".header_1 .header_logo_wrap"
    );

        jQuery(".header_1 .tt_menus_ul .tt_menu_item.item").prependTo(".header_1 .tt-megamenu1 .tt-mega_menu1 .tt_menus_ul1");


                jQuery("#shopify-section-TT-megamenu .tt-mega_menu .header-contact ").appendTo(".top_header_1 .top_header_1_link");


    
       

    jQuery(".header_1 .header_language").appendTo(
      ".header_1 .top_header_1_link "
    );
    jQuery(".header_1 .header_currency").insertAfter(
      ".header_1 .top_header_1_link .header_language"
    );
    jQuery(".header_1 .left-nav").prependTo(".header_1_wrapper .top_header_1");
    jQuery(".header_2 .customer_account .header_language ").appendTo(
      ".header_2 .header-2-logo-wrap"
    );
    jQuery(".header_2 .customer_account .header_currency ").appendTo(
      ".header_2 .header-2-logo-wrap"
    );
  }
}
jQuery(document).ready(function () {
  responsiveMenu();

  jQuery(".product-write-review").on("click", function (e) {
    e.preventDefault();
    $("a[href='#tab-2']").trigger("click");
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".product_tab_wrapper").offset().top - 150,
      },
      1000
    );
  });
});

jQuery(window).resize(function () {
  responsiveMenu();
  var w_width = $(window).width();
  $(".slider-content-main-wrap").css("width", w_width);
});
function height() {
  var maxHeight = $(".product__media.imgs img").height();
  $(".product__media.extra-video").height(maxHeight);
  $(".product__media.video").height(maxHeight);
}
$(document).ready(function () {
  height();
});
$(window).resize(function () {
  height();
});
$(window).scroll(function () {
  height();
});

function productcartsticky() {
if (jQuery(window).width() > 319) {
if (jQuery(this).scrollTop() > 550) {
jQuery('.add-to-cart-sticky').addClass("fixed");

} else {
jQuery('.add-to-cart-sticky').removeClass("fixed");
}
} else {
jQuery('.add-to-cart-sticky').removeClass("fixed");
}
}
$(document).ready(function() {
productcartsticky();
});
jQuery(window).resize(function() {
productcartsticky();
});
jQuery(window).scroll(function() {
productcartsticky();
});




function footerToggle() {
  if (jQuery(window).width() < 992) {
    // jQuery('.left-sidebar.sidebar').insertAfter('.collection_wrapper');
    jQuery(".block_newsletter").prependTo(".footer-wrap .text-left.grid");
    // jQuery('.sidebar .collection_sidebar .sidebar-block').insertAfter('.filter-wrapper');
    jQuery(
      ".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4"
    ).addClass("toggle");
    jQuery(
      ".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget"
    )
      .children(":nth-child(2)")
      .css("display", "none");
    jQuery(
      ".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active"
    )
      .children(":nth-child(2)")
      .css("display", "block");
    jQuery(
      ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
    ).unbind("click");
    jQuery(
      ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
    ).on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast");
    });
    jQuery(
      ".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4"
    ).addClass("toggle");
    jQuery(
      ".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget "
    )
      .children(":nth-child(2)")
      .css("display", "none");
    jQuery(
      ".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active"
    )
      .children(":nth-child(2)")
      .css("display", "block");
    jQuery(
      ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
    ).unbind("click");
    jQuery(
      ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
    ).on("click", function () {
      jQuery(this)
        .parent()
        .toggleClass("active")
        .children(":nth-child(2)")
        .slideToggle("fast");
    });
    jQuery(".footer-middle .footer-detail.footer-column").insertBefore(
      ".footer-wrap .footer-logo-content"
    );
  } else {
    // jQuery('.left-sidebar.sidebar').insertBefore('.collection_wrapper');
    jQuery(".footer-detail.footer-column").prependTo(
      ".footer-middle .container .row"
    );
    jQuery(".sidebar-block").prependTo(".collection_sidebar");
    jQuery(".block_newsletter").appendTo(".footer-wrap .text-left.grid");
    jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").unbind("click");
    jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").removeClass(
      "toggle"
    );
    jQuery(".sidebar .widget,.sidebar-block .widget")
      .children(":nth-child(2)")
      .css("display", "block");
  }
}
jQuery(document).ready(function () {
  footerToggle();
});
jQuery(window).resize(function () {
  footerToggle();
});
function splitStr(string, seperator) {
  return string.split(seperator);
}
function countDownIni(countdown) {
  $(countdown).each(function() {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10)
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown')
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).parent(".simple-countdown").addClass("countdown-block");
      $(this).parent().addClass('countdown-enable');
      console.log();
      countdown.countdown(promoperiod, function(event) {
        countdown.html(event.strftime('<span><span class="left-txt">LEFT</span><span>%D</span><span class="time-txt">days</span></span>' + '<span><span>%H</span><span class="time-txt">hours</span></span>' + '<span><span>%M</span><span class="time-txt">min</span></span>' + '<span><span class="second">%S</span><span class="time-txt">sec</span></span>'))
      })
    }
  })
}
function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (i) {
    var $this = $(this);
    if (!$this.hasClass("hb-in-viewport")) {
      setTimeout(function () {
        $this.addClass("hb-in-viewport");
      }, 180 * i);
    }
  });
}
$(window).scroll(function () {
  hb_animated_contents();
});
$(window).load(function () {
  hb_animated_contents();
});
function sidebarsticky() {
  if ($(document).width() <= 1199) {
    jQuery(
      ".left-sidebar.sidebar,.right-sidebar.sidebar.collection_right,.collection_left"
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 30,
    });
    jQuery(
      ".design_2 .additinal-product,.design_2 .product-information, .design_2 .product-wrapper-owlslider"
    ).theiaStickySidebar({
      additionalMarginTop: 30,
    });
  } else if ($(document).width() >= 1200) {
    jQuery(
      ".left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left"
    ).theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 130,
    });
    jQuery(
      ".design_2 .additinal-product,.design_2 .product-information, .design_2 .product-wrapper-owlslider"
    ).theiaStickySidebar({
      additionalMarginTop: 50,
    });
  }
}
jQuery(document).ready(function () {
  sidebarsticky();
});
jQuery(window).resize(function () {
  sidebarsticky();
});
/* responsive accordian menu*/
jQuery(function () {
  var Accordion = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    $("ul.tt_menus_ul1 > li.tt_mm_hassub").addClass("active");
    // Variables privadas
    var links = this.el.find("li.tt_mm_hassub .mobile-nav__sublist-trigger");
    // Evento
    links.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
  };
  Accordion.prototype.dropdown = function (e) {
    e.preventDefault();
    var $el = e.data.el;
    ($this = $(this)), ($next = $this.next());

    $next.slideToggle();
    $this.parent().toggleClass("open");

    if (!e.data.multiple) {
      $el
        .find("li.tt_mm_hassub .tt_sub_menu_wrap")
        .not($next)
        .slideUp()
        .parent()
        .removeClass("open");
    }
  };
  var accordion = new Accordion($(".tt_menus_ul1"), false);
});
jQuery(function () {
  if (!$("body").hasClass("fullnav-open")) {
    var Accordion = function (el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;
      // Variables privadas
      var links = this.el.find("li.tt_mm_hassub .mobile-nav__sublist-trigger");
      // Evento
      links.on(
        "click",
        { el: this.el, multiple: this.multiple },
        this.dropdown
      );
    };
    Accordion.prototype.dropdown = function (e) {
      var $el = e.data.el;
      ($this = $(this)), ($next = $this.next());

      $next.slideToggle();
      $this.parent().toggleClass("open");

      if (!e.data.multiple) {
        $el
          .find("li.tt_mm_hassub .tt_sub_menu_wrap")
          .not($next)
          .slideUp()
          .parent()
          .removeClass("open");
      }
    };
    var accordion = new Accordion($(".tt_menus_ul"), false);
  }
});
jQuery(function () {
  var Accordions = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var link = this.el.find(".toggle");
    // Evento
    link.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
  };
  Accordions.prototype.dropdown = function (e) {
    var $el = e.data.el;
    ($this = $(this)), ($next = $this.next());

    $next.slideToggle();
    $this.parent().toggleClass("active");

    if (!e.data.multiple) {
      $el
        .find(".inline-list")
        .not($next)
        .slideUp()
        .parent()
        .removeClass("active");
    }
  };
  var accordions = new Accordions($(".footer-column"), false);
});

// ------------------

$(document).ready(function () {
  jQuery(".product-wrapper .product-description").addClass("without_var");
  jQuery(".product-wrapper .product-description .color-size")
    .parent()
    .removeClass("without_var");
  jQuery(
    ".product-wrapper .product-description .color-size ul.item-swatch , .product-wrapper .product-description .color-size ul.product-size"
  ).removeClass("pro_variant");
  jQuery(
    ".product-wrapper .product-description .color-size ul.item-swatch li, .product-wrapper .product-description .color-size ul.product-size li"
  )
    .parent()
    .addClass("pro_variant");
  $("a.product-write-review").click(function () {
    $(
      ".product-single__description ul.nav.nav-tabs li.nav-item a.nav-link"
    ).removeClass("active");
    $(".product-single__description .tab-container .tab-pane").removeClass(
      "active"
    );
    $(
      ".product-single__description ul.nav.nav-tabs li.nav-item:nth-child(2) a.nav-link"
    ).addClass("active");
    $(".product-single__description .tab-container div#tab-2").addClass(
      "active"
    );
  });
});
jQuery(".overlay").click(function () {
  jQuery("header.site-header .fixed-cart-wrap.active").removeClass("active");
  jQuery("header.site-header div#slidedown-cart").removeClass("active");
  jQuery("body").removeClass("cart_toggle");
});
jQuery(".dark-light-mode .dark-mode").on("click", function (event) {
  jQuery("body").addClass("darkmode");
});
jQuery(".dark-light-mode .light-mode").on("click", function (event) {
  jQuery("body").removeClass("darkmode");
});

$(".dark-light-mode.nav-tabs li:first-child").click(function () {
  $(".dark-light-mode.nav-tabs li:first-child").addClass("active");
  $(".dark-light-mode.nav-tabs li:last-child").removeClass("active");
});

$(".dark-light-mode.nav-tabs li:last-child").click(function () {
  $(".dark-light-mode.nav-tabs li:last-child").addClass("active");
  $(".dark-light-mode.nav-tabs li:first-child").removeClass("active");
});

/*------------------------ END ------------------------*/
// grid - list remove

function bindgrid() {
  if (localStorage.getItem("display") == "grid") {
    jQuery("#grid-view").trigger("click");
  } else if (localStorage.getItem("display") == "grids") {
    jQuery("#grid-views").trigger("click");
  } else if (localStorage.getItem("display") == "list") {
    jQuery("#list-view").trigger("click");
  } else if (localStorage.getItem("display") == "short-list") {
    jQuery("#short-list-view").trigger("click");
  } else {
    jQuery("#grid-view").trigger("click");
  }

  if (jQuery(window).width() < 768) {
    if (jQuery("#grid-view").hasClass("active")) {
      jQuery("#grid-views").toggleClass("active");
      jQuery("#grid-views").trigger("click");
      jQuery("#grid-view").removeClass("active");
    }
  }
  if (jQuery(window).width() < 481) {
    if (jQuery("#list-view").hasClass("active")) {
      jQuery("#short-list-view").toggleClass("active");
      jQuery("#short-list-view").trigger("click");
      jQuery("#list-view").removeClass("active");
    }
  }
}
$(document).ready(function () {
  bindgrid();
});

$(window).load(function () {
  bindgrid();
});

$(window).resize(function () {
  bindgrid();
});
